var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},_vm._l((_vm.devices.edges),function({node}){return _c('div',{staticClass:"col-12 col-sm-6 col-md-4 col-lg-3 col-xl2-2"},[_c('mini-crane-card',{attrs:{"id":node.id}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }